import Loader from "./Display/Loader";
import Stack from "@mui/material/Stack";
import Avatar from "@mui/material/Avatar";
import { useEffect, useState } from "react";
import NoDataDiv from "./Display/NoDataDiv";
import { Theme } from "../data/style/Theme";
import { useAuth } from "../context/AuthContext";
import ToggleButton from "./buttons/ToggleButton";
import StorageIcon from "@mui/icons-material/Storage";
import useScreenSize from "../context/ScreenContext";
import { genderOptions } from "../data/assets/arrays";
import { getWorkoutLeaderboard } from "../api/workouts";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import {
  MainText,
  MainTitle,
  scrollBar,
  SpacedRow,
  CenteredRow,
  AllCenteredColumn,
} from "../data/style/Style";

const WorkoutLeaderboard = (props) => {
  const client = useQueryClient();
  let { workoutId, isTrending, gd, drawer } = props;
  const { size, mobileDevice } = useScreenSize();
  const { user } = useAuth();
  var [width] = size;
  const [workoutType, setWorkoutType] = useState(0);
  const [isWorkoutPublic, setIsWorkoutPublic] = useState(false);
  const [gender, setGender] = useState(isTrending ? gd : user.gender);
  const queryStatus = client.getQueryState(["workout", parseInt(workoutId)]);

  const NoDataIcon = {
    fontSize: width < 750 ? "3rem" : "4rem",
    color: Theme.palette.orange,
  };
  useEffect(() => {
    if (queryStatus.status === "success") {
      if (
        client.getQueryData(["workout", parseInt(workoutId)]).isPublic ||
        client.getQueryData(["workout", parseInt(workoutId)]).isWeekly
      ) {
        refetch();
      }
      setWorkoutType(
        client.getQueryData(["workout", parseInt(workoutId)]).type,
      );
      setIsWorkoutPublic(
        client.getQueryData(["workout", parseInt(workoutId)]).isPublic ||
          client.getQueryData(["workout", parseInt(workoutId)]).isWeekly,
      );
    }
  }, [queryStatus]);

  const { data, isPending, refetch } = useQuery({
    queryFn: ({ signal }) =>
      getWorkoutLeaderboard({ workoutId, gender, signal }),
    queryKey: ["workout", workoutId, "leaderboard", gender],
    enabled: isTrending,
    retry: false,
    throwOnError: (error) => console.log(error),
  });

  return (
    <Stack
      minHeight={mobileDevice || width < 750 ? "250px" : "150px"}
      height={
        drawer
          ? "95vh"
          : mobileDevice || width < 750
            ? "40%"
            : isTrending
              ? "100%"
              : "62%"
      }
      overflow={"auto"}
      flex={1}
      minWidth={mobileDevice ? "270px" : "350px"}
      sx={scrollBar}
    >
      {isPending ? (
        <Loader height={"100%"} />
      ) : (
        <Stack height={"100%"} gap={1}>
          {isWorkoutPublic ? (
            <>
              <SpacedRow alignItems={"center"} gap={1}>
                <MainTitle>
                  {isTrending ? (
                    <>{gd === 0 ? "Males" : "Females"}</>
                  ) : (
                    "Leaderboard"
                  )}
                </MainTitle>
                {!isTrending && (
                  <ToggleButton
                    items={genderOptions}
                    setId={setGender}
                    id={gender}
                  />
                )}
              </SpacedRow>
              {data?.length > 0 ? (
                <Stack gap={1.5} p={1}>
                  {data.map((item, index) => (
                    <SpacedRow
                      key={index}
                      alignItems={"center"}
                      sx={{
                        background:
                          item.user === user.id
                            ? "rgba(249,115,22,.06)"
                            : Theme.palette.card,
                        borderRadius: 3,
                        border: 1,
                        borderColor:
                          item.user === user.id
                            ? "rgba(249,115,22,.28)"
                            : Theme.palette.border,
                        p: 1,
                      }}
                    >
                      <CenteredRow gap={1}>
                        <Avatar
                          sx={{
                            width: 40,
                            height: 40,
                          }}
                          alt={item.athlete_name}
                          src={item.athlete_image}
                        />
                        <MainText
                          fontSize={mobileDevice ? "0.8rem" : "1rem"}
                          sx={{
                            color:
                              item.user === user.id &&
                              Theme.palette.orange + " !important",
                          }}
                        >
                          {item.athlete_name}
                        </MainText>
                        {item.user === user.id && (
                          <AllCenteredColumn
                            p={0.5}
                            sx={{
                              border: 1,
                              borderColor: "rgba(249,115,22,0.3)",
                              borderRadius: 2,
                              background: "rgba(249,115,22,0.14)",
                            }}
                          >
                            <MainText
                              fontSize={"0.5rem"}
                              sx={{
                                color: Theme.palette.orange + " !important",
                              }}
                            >
                              YOU
                            </MainText>
                          </AllCenteredColumn>
                        )}
                      </CenteredRow>
                      <MainText fontSize={mobileDevice ? "0.8rem" : "1rem"}>
                        {workoutType !== 3 ? (
                          <>{item.converted_score}</>
                        ) : (
                          <>{item.result === 1 ? "Success" : "Failed"}</>
                        )}
                      </MainText>
                    </SpacedRow>
                  ))}
                </Stack>
              ) : (
                <NoDataDiv
                  icon={<span style={{ fontSize: "3rem" }}>🏁</span>}
                  header={"No scores yet."}
                  text={"Be the first to submit."}
                  height={"100%"}
                />
              )}
            </>
          ) : (
            <NoDataDiv
              icon={<StorageIcon sx={NoDataIcon} />}
              text={"Leaderboard is available only in public workouts."}
              height={"100%"}
            />
          )}
        </Stack>
      )}
    </Stack>
  );
};
export default WorkoutLeaderboard;
